<script>
    // Stores 
    import { textSite } from '../store.js';    

	// Componentes Svelte
    import { Router, Link, link , Route } from "svelte-routing";
    import PageHeader from './../components/PageHeader.svelte';
    import ListaImoveis from './../components/ListaImoveis.svelte'

	let filtrosDestaques = {nt:atria.rent, tipo_negociacao:atria.rent, cidade:'Canela', pageSize:6, random: true};

    //Event snippet for Formulário Site conversion page
    gtag('event', 'conversion', {'send_to': 'AW-11107740137/ZdjtCNWwpeoYEOnTyrAp'});

</script>

<section class="conteudo-internas">
    <PageHeader title="Obrigado pelo contato! Em breve retornaremos sua mensagem" buttons="" ></PageHeader>
    <div class="container">
        <section class="section lista-imoveis">
            <ListaImoveis filters={filtrosDestaques} showPaginator={false} />
        </section>        
    </div>
</section>